import { render, staticRenderFns } from "./Relay.vue?vue&type=template&id=cf140e06&scoped=true&"
import script from "./Relay.vue?vue&type=script&lang=js&"
export * from "./Relay.vue?vue&type=script&lang=js&"
import style0 from "./Relay.vue?vue&type=style&index=0&id=cf140e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf140e06",
  null
  
)

export default component.exports